var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGstVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.062 13.355a10.094 10.094 0 01-2.4 3.764 12.548 12.548 0 01-4.692 2.8c-.147.05-.3.077-.456.078h-.017a1.448 1.448 0 01-.472-.08 12.546 12.546 0 01-4.697-2.8 10.075 10.075 0 01-2.395-3.759 21.806 21.806 0 01-.874-7.91v-.035c.009-.194.015-.4.018-.622.01-.535.22-1.046.588-1.43a2.1 2.1 0 011.398-.647A8.143 8.143 0 007.625.355l.008-.01a1.268 1.268 0 011.727 0l.015.011a8.145 8.145 0 005.563 2.36 2.1 2.1 0 011.397.645c.369.385.579.896.589 1.43 0 .227.009.43.018.623v.015a21.841 21.841 0 01-.88 7.926z",
    fill: "#84F2C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.062 13.356a10.095 10.095 0 01-2.4 3.764 12.548 12.548 0 01-4.692 2.799c-.146.052-.3.079-.456.081V0c.314.004.616.126.847.34l.012.012a8.145 8.145 0 005.563 2.36 2.1 2.1 0 011.398.645c.368.385.578.896.588 1.43 0 .226.009.43.018.622v.02a21.844 21.844 0 01-.878 7.927z",
    fill: "#1CBB7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10.002a5.817 5.817 0 01-1.68 4.085 5.742 5.742 0 01-4.054 1.705h-.02a5.735 5.735 0 01-4.068-1.696 5.81 5.81 0 01-1.685-4.095 5.81 5.81 0 011.685-4.094A5.735 5.735 0 018.496 4.21h.02a5.742 5.742 0 014.053 1.705 5.817 5.817 0 011.68 4.086z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10.002a5.817 5.817 0 01-1.68 4.085 5.742 5.742 0 01-4.054 1.705V4.212a5.742 5.742 0 014.053 1.706 5.817 5.817 0 011.68 4.084z",
    fill: "#E0E9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.46 8.99l-2.928 2.948-.632.637a.763.763 0 01-1.083 0l-1.36-1.37a.774.774 0 01.545-1.301c.2-.003.392.073.537.212l.82.825 3.02-3.04a.763.763 0 011.293.549.773.773 0 01-.21.54h-.002z",
    fill: "#1CBB7A"
  })));
}

export default SvgGstVerified;